export default "__VITE_ASSET__DqTIkl7J__"